import { render, staticRenderFns } from "./PremiumIndicator.vue?vue&type=template&id=55dc640d"
import script from "./PremiumIndicator.vue?vue&type=script&lang=js"
export * from "./PremiumIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports